import { Component, input } from '@angular/core';
import { AdvertViewModel } from '@models/advert/advert';
import { TranslateModule } from '@ngx-translate/core';
import { NumeralPipe } from '../../../../pipes/numeral.pipe';
import { ConvertDatePipe } from '@pipes/convert-date.pipe';

@Component({
    selector: 'hunting-area-header-stats',
    templateUrl: './hunting-area-header-stats.component.html',
    imports: [TranslateModule, NumeralPipe, ConvertDatePipe]
})
export class HuntingAreaHeaderStatsComponent {
    readonly advert = input<AdvertViewModel>(undefined);
}
